import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-[#F5FAFD]" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-28">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-29">
            <h2 className="font-serif text-4xl md:text-5xl text-[#3A5F7D] mb-6 leading-tight" data-id="element-30">
              A Sanctuary for the <br data-id="element-31" />
              <span className="text-[#5B9BD5] italic" data-id="element-32">Modern Soul</span>
            </h2>
            <p className="text-lg text-[#6B8FA8] mb-6 leading-relaxed" data-id="element-33">
              Founded in 1985, Supradhyan Enlightenment Center has been a beacon
              of light for seekers from all walks of life. Nestled in the serene
              foothills, our center offers a sacred space where time slows down
              and the spirit awakens.
            </p>
            <p className="text-lg text-[#6B8FA8] mb-8 leading-relaxed" data-id="element-34">
              We believe that meditation is not just a practice, but a way of
              living. Our holistic approach combines physical yoga, breathwork,
              and deep meditation to harmonize body, mind, and soul.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-35">
              {['Ancient Vedic traditions adapted for modern life', 'Serene 50-acre campus surrounded by nature', 'Experienced guides with decades of practice', 'Organic, vegetarian cuisine for purification'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-36">
                  <CheckCircle2 className="w-6 h-6 text-[#5B9BD5] flex-shrink-0 mt-0.5" data-id="element-37" />
                  <span className="text-[#3A5F7D] font-medium" data-id="element-38">{item}</span>
                </li>)}
            </ul>

            <button className="bg-[#5B9BD5] text-white px-8 py-3 rounded-full hover:bg-[#4A7FB8] transition-colors shadow-lg" data-id="element-39">
              Read Our Story
            </button>
          </motion.div>

          {/* Image Grid */}
          <div className="relative" data-id="element-40">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="grid grid-cols-2 gap-4" data-id="element-41">
              <img src="https://images.unsplash.com/photo-1544367563-12123d8965cd?q=80&w=2070&auto=format&fit=crop" alt="Meditation hall" className="rounded-2xl w-full h-64 object-cover shadow-lg translate-y-8" data-id="element-42" />
              <img src="https://images.unsplash.com/photo-1519834785169-98be25ec3f84?q=80&w=1964&auto=format&fit=crop" alt="Garden path" className="rounded-2xl w-full h-64 object-cover shadow-lg" data-id="element-43" />
            </motion.div>

            {/* Decorative circle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] border border-[#C5E0F4]/40 rounded-full -z-10" data-id="element-44" />
          </div>
        </div>
      </div>
    </section>;
}